import { render, staticRenderFns } from "./OneStepOrder.vue?vue&type=template&id=90d4887a"
import script from "./OneStepOrder.vue?vue&type=script&lang=js"
export * from "./OneStepOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports